"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __importStar(require("lodash"));

var i18n_1 = __importDefault(require("../i18n"));

var _SECOND = 1000;

var _MINUTES = 60 * _SECOND;

var _HOUR = 60 * _MINUTES;

var _DAY = 24 * _HOUR;

function gap(date) {
  var lite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  try {
    var pass = new Date(date);
    var now = new Date();

    var _gap = now - pass;

    var d = _gap / _DAY;
    var h = _gap / _HOUR;
    var m = _gap / _MINUTES;

    if (d >= 1) {
      if (lite) {
        return parseInt(d + '') + "d";
      } else {
        return parseInt(d + '') + "d" + parseInt(_gap % _DAY / _DAY * 24 + '') + "h";
      }
    } else if (h >= 1) {
      if (lite) {
        return parseInt(h + '') + "h";
      } else {
        return parseInt(h + '') + "h" + parseInt(_gap % _HOUR / _HOUR * 60 + '') + "m";
      }
    } else {
      return parseInt(m + '') + "m";
    }
  } catch (error) {
    return '...';
  }

  ;
}

exports.gap = gap;

function getGapByFirebaseTimestamp(ts, lite) {
  if (_.has(ts, 'seconds') && _.has(ts, 'nanoseconds')) {
    return gap(ts.seconds * 1000 + ts.nanoseconds / 1000000, lite);
  }

  return '...';
}

exports.getGapByFirebaseTimestamp = getGapByFirebaseTimestamp;

function convertToTimestamp(ts) {
  if (_.isFinite(ts)) {
    return ts;
  } else if (_.has(ts, 'seconds') && _.has(ts, 'nanoseconds')) {
    return ts.seconds * 1000 + ts.nanoseconds / 1000000;
  } else {
    throw new Error("Unknown timestamp");
  }
}

function getGap(anyDate) {
  var timestamp = convertToTimestamp(anyDate);
  var pass = new Date(timestamp);
  var now = new Date();
  var gap = now - pass;
  var d = gap / _DAY;
  var h = gap / _HOUR;
  var m = gap / _MINUTES;
  return {
    d: d,
    h: h,
    m: m,
    dt: parseInt(d + '') + '',
    ht: parseInt(h + '') + '',
    mt: parseInt(m + '') + ''
  };
}

exports.getGap = getGap;

function getLastEdit(anyDate) {
  try {
    var _getGap = getGap(anyDate),
        d = _getGap.d,
        h = _getGap.h,
        m = _getGap.m,
        dt = _getGap.dt,
        ht = _getGap.ht,
        mt = _getGap.mt;

    if (d >= 1) {
      return i18n_1.default.t('Time_Gap_Last_Edit_Day', {
        day: dt
      });
    } else if (h >= 1) {
      return i18n_1.default.t('Time_Gap_Last_Edit_Hour', {
        hour: ht
      });
    } else {
      return i18n_1.default.t('Time_Gap_Last_Edit_Minute', {
        minute: mt
      });
    }
  } catch (error) {
    return i18n_1.default.t('Time_Gap_Last_Edit_Unknown');
  }
}

exports.getLastEdit = getLastEdit;

function getLightGap(anyDate) {
  try {
    var _getGap2 = getGap(anyDate),
        d = _getGap2.d,
        h = _getGap2.h,
        m = _getGap2.m,
        dt = _getGap2.dt,
        ht = _getGap2.ht,
        mt = _getGap2.mt;

    if (d >= 1) {
      return i18n_1.default.t('Time_Gap_Light_Day', {
        day: dt
      });
    } else if (h >= 1) {
      return i18n_1.default.t('Time_Gap_Light_Hour', {
        hour: ht
      });
    } else {
      return i18n_1.default.t('Time_Gap_Light_Minute', {
        minute: mt
      });
    }
  } catch (error) {
    return i18n_1.default.t('Time_Gap_Light_Unknown');
  }
}

exports.getLightGap = getLightGap;